import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
export const fetchAdConsentLabel = lang => http.get(`consent-manager/v1/data-processing-notices/63313/${lang}`, {
  portalId: PortalIdParser.get()
});